






























































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';

import format from '@/libs/numberFormat';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Loader from '@/components/Loader.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';
import { Bank, DisbursementDetailResponse } from '@/libs/api.interfaces';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
  },
  methods: {
    format,
  },
})
export default class DisbursementDetail extends Vue {
  loading = true;
  bankList: Bank = {};
  detail: DisbursementDetailResponse = {} as DisbursementDetailResponse;

  approvedBy: string | null = null;
  requestedBy: string | null = null;
  rejectedBy: string | null = null;

  format!: (val: number) => string;

  async mounted() {
    await Promise.all([this.getDetail(), this.getBanks()]);
    this.loading = false;
  }

  async getBanks() {
    try {
      const { data } = await api.get<Bank[]>('/bank');
      const banks = data[0];
      this.bankList = banks;
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to load bank list');
    }
  }

  async getDetail() {
    try {
      const { data } = await api.get<DisbursementDetailResponse>(`/disbursement/detail/${this.$route.params.id}`);
      this.detail = data;

      data.detail.forEach((e) => {
        if (e.status === 'REQUESTED') {
          this.requestedBy = e.name;
        } else if (e.status === 'APPROVED') {
          this.approvedBy = e.name;
        } else if (e.status === 'REJECTED') {
          this.rejectedBy = e.name;
        }
      });
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;

      if (err.response) {
        showToast(ToastType.FAILED, `Error ${error.response?.status}`, err.response.data.error.message);
      } else {
        showToast(ToastType.FAILED, 'Error', 'Error fetching the disbursement detail');
      }
    }
  }

  dateFormat = (time: string) => {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
